/**
  * @desc provides a safe way to apply JSON.parse to a variable
  *
  * @param {string} str the string we need to parse as JSON
  *
  * @returns {object | string} JSON parsed string or void string
*/
function parseJSON(str) {
  let result;
  try {
    result = JSON.parse(str);
  } catch (e) {
    result = null;
  }
  return result;
}

export default parseJSON;
